import MyLibrary from '.';
import { RouteType } from '@/lib/route';

const MyLibraryRoutes: RouteType = {
  path: '/my-library',
  component: MyLibrary,
};

export default MyLibraryRoutes;
